module.exports = __webpack_public_path__ + "img/p2-17.61b1a2a0.png";